import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { findObjectCatalogAct, loadObjectCatalogByIdAct, saveObjectCatalogAct, saveSuccessObjectCatalogAct, 
    setViolationsObjectCatalogAct, showMsgErrorAct, updateObjectCatalogAct, updateSuccessObjectCatalogAct } from "./object-catalog.action";
import { ObjectCatalogService } from "../../services/object-catalog.service";



@Injectable()
export class ObjectCatalogEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private objectCatalogService = inject(ObjectCatalogService);
    private alerta = inject(AlertaService);

    findObjectCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findObjectCatalogAct),
            exhaustMap(action => this.objectCatalogService.findObjectCatalogById(action.id)
                .pipe(
                    map(object => loadObjectCatalogByIdAct({ object })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/objectsCatalog']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveObjectCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveObjectCatalogAct),
            exhaustMap(action => this.objectCatalogService.createObjectCatalog(action.objectNew)
                .pipe(
                    map(objectNew => saveSuccessObjectCatalogAct({ objectNew })),
                    /*catchError(error => (error.status == 400) ? of(setViolationsObjectCatalogAct({ objectForm: action.objectNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))*/
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsObjectCatalogAct({ objectForm: action.objectNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    //)
                    )
                )
            )
        )
    );

    /*showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });*/
    showMsgErrorEffect$ = createEffect(() =>
            this.actions$.pipe(
              ofType(showMsgErrorAct),
              tap(action => {
                const detail = action.error?.error?.message || action.error?.message || null;
                //console.log('showMsgErrorEffect 111:');
                this.alerta.error(
                  'Se ha presentado un error interno Catalogo Beneficios',
                  detail ? { detail } : undefined
                );
                //console.log('showMsgErrorEffect 222:');
              })
            ),
            { dispatch: false }
          );

    saveSuccessObjectCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessObjectCatalogAct),
        tap(() => {
            this.router.navigate(['/objectsCatalog']);
            this.alerta.correct("Beneficio creado con exito!");
        })
    ), { dispatch: false });

    updateObjectCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateObjectCatalogAct),
            exhaustMap(action => this.objectCatalogService.updateObjectCatalog(action.objectUpdated)
                .pipe(
                    map(objectUpdated => updateSuccessObjectCatalogAct({ objectUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsObjectCatalogAct({ objectForm: action.objectUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessObjectCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessObjectCatalogAct),
        tap(() => {
            this.router.navigate(['/objectsCatalog']);
            this.alerta.correct("Beneficio editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}